import { Modal, Box, Typography, Button } from "@mui/material";

const CMSPartnerDetailsModal = ({ open, onClose, partner }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: "8px",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Partner Details
        </Typography>
        <Typography variant="body1">
          <strong>Name:</strong> {`${partner.firstName} ${partner.lastName}`}
        </Typography>
        <Typography variant="body1">
          <strong>Phone:</strong> {partner.merchantPhoneNumber}
        </Typography>
        <Typography variant="body1">
          <strong>Email:</strong> {partner.emailId}
        </Typography>
        <Typography variant="body1">
          <strong>Company:</strong> {partner.companyLegalName}
        </Typography>
        <Typography variant="body1">
          <strong>Address:</strong> {`${partner.merchantAddress1}, ${partner.merchantCityName}`}
        </Typography>
        <Typography variant="body1">
          <strong>KYC Status:</strong> {partner.kycStatus}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={onClose}
          sx={{ mt: 2 }}
        >
          Close
        </Button>
      </Box>
    </Modal>
  );
};

export default CMSPartnerDetailsModal;
